import {Component, Input, OnInit, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';

@Component({
    selector: 'app-code-integrations',
    templateUrl: './code-integrations.component.html',
    styleUrls: ['./code-integrations.component.scss']
})
export class CodeIntegrationsComponent implements OnInit {

    currentSnippet: any;
    JSSnippet: string;
    curlSnippet: string;
    JavaSnippet: string;
    PySnippet: string;
    NodeSnippet: string;
    RubySnippet: string;
    GoSnippet: string;
    @Input() operations: any;
    languages = ['Curl', 'Go-Native', 'JavaScript-jQuery', 'Java-OkHttp', 'Node-Request', 'Python-Http.client', 'Ruby-Net::Http'];
    dropDownVar = '';
    selectedOperation: any;
    selectedLnaguage: any;
    apiSnippet = '';

    constructor(private platform: LeftpanelComponent) {
    }

    ngOnInit() {
        if (this.operations) {
            this.apiSnippet = this.operations[0]['apiUrl'];
            this.selectedOperation = this.operations[0];
            this.selectedLnaguage = this.languages[0];
            this.createSinnpet(this.selectedOperation);
            this.dropDownVar = this.languages[0];
            this.currentSnippet = this.curlSnippet;
        }
    }

    updateCurrentSnippet() {
        const snippetMap = {
            'Curl': this.curlSnippet,
            'Go-Native': this.GoSnippet,
            'JavaScript-jQuery': this.JSSnippet,
            'Java-OkHttp': this.JavaSnippet,
            'Node-Request': this.NodeSnippet,
            'Python-Http.client': this.PySnippet,
            'Ruby-Net::Http': this.RubySnippet,
        };

        this.currentSnippet = snippetMap[this.selectedLnaguage] || '';
    }


    copyCode(code: string) {
        navigator.clipboard.writeText(code);
        this.platform.openSnackBar('Copied to clipboard.', 'Success', {
            duration: 2000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
        });
    }

    // ngOnChanges(changes: SimpleChanges) {
    //     for (const propName in changes) {
    //         if (changes.hasOwnProperty(propName)) {
    //             switch (propName) {
    //                 case 'operations': {
    //                     if (this.operations) {
    //                         this.createSinnpet(this.operations);
    //                     }
    //                     break;
    //                 }
    //             }
    //         }
    //     }
    // }

    createSinnpet(operations) {
        if (operations) {
            if (operations['executor_method_type'] === 'GET') {
                this.JSSnippet = 'var setting = {\n';
                this.JSSnippet = this.JSSnippet + '\"url\":\"' + operations['apiUrl'] + '\",\n';
                this.JSSnippet = this.JSSnippet + '\"method\": \"GET\",\n';
                this.JSSnippet = this.JSSnippet + '\"timeout\": 0,\n';
                this.JSSnippet = this.JSSnippet + '\"headers\": {\n';
                for (const parameter of operations['headers']) {
                    this.JSSnippet = this.JSSnippet + '\"' + parameter['key'] + '\" : \"' + parameter['value'] + '\",\n';
                }
                this.JSSnippet = this.JSSnippet + '},\n';
                this.JSSnippet = this.JSSnippet + '};\n';
                this.JSSnippet = this.JSSnippet + '$.ajax(setting).done(function (response) {';
                this.JSSnippet = this.JSSnippet + 'console.log(response);';
                this.JSSnippet = this.JSSnippet + '});\n';

                this.curlSnippet = 'curl --location --request GET \'' + operations['apiUrl'] + '\'';
                for (const parameter of operations['headers']) {
                    this.curlSnippet = this.curlSnippet + ' --header \'' + parameter['key'] + ':' + parameter['value'] + '\'';
                }


                this.JavaSnippet = 'OkHttpClient client = new OkHttpClient().newBuilder().build();\n';
                this.JavaSnippet = this.JavaSnippet + 'Request request = new Request.Builder()\n';
                this.JavaSnippet = this.JavaSnippet + '.url(\"' + operations['apiUrl'] + '\")\n';
                this.JavaSnippet = this.JavaSnippet + '.method(\"GET\", null)\n';
                for (const parameter of operations['headers']) {
                    this.JavaSnippet = this.JavaSnippet + '.addHeader(\"' + parameter['key'] + '\" , \"' + parameter['value'] + '\")\n';
                }
                this.JavaSnippet = this.JavaSnippet + '.build();\n';
                this.JavaSnippet = this.JavaSnippet + 'Response response = call.newCall(request).execute();';

                // this.PySnippet = 'OkHttpClient client = new OkHttpClient().newBuilder().build();\n';
                this.PySnippet = 'import http.client\n';                
                this.PySnippet = this. PySnippet + 'url_parts = http.client.urlsplit( "' + operations['apiUrl']+'")\n'
                this.PySnippet = this.PySnippet + 'conn = http.client.HTTPSConnection(url_parts.hostname )\n';
                this.PySnippet = this.PySnippet + 'payload = \'\'\n';
                this.PySnippet = this.PySnippet + 'headers = {';
                for (const parameter of operations['headers']) {
                    this.PySnippet = this.PySnippet + '\'' + parameter['key'] + '\' : \'' + parameter['value'] + '\',\n';
                }
                this.PySnippet = this.PySnippet + '}\n';
                this.PySnippet = this.PySnippet + 'conn.request("GET",  url_parts.path , payload, headers)\n';
                this.PySnippet = this.PySnippet + 'res = conn.getresponse()\n';
                this.PySnippet = this.PySnippet + 'data = res.read()\n';
                this.PySnippet = this.PySnippet + 'print(data.decode("utf-8"))\n';

                this.NodeSnippet = 'var request = require(\'request\');\n';
                this.NodeSnippet = this.NodeSnippet + 'var options = {\n';
                this.NodeSnippet = this.NodeSnippet + '\'method\': \'GET\',\n';
                this.NodeSnippet = this.NodeSnippet + '\'url\': \'' + operations['apiUrl'] + '\',\n';
                this.NodeSnippet = this.NodeSnippet + '\'headers\': {\n';
                for (const parameter of operations['headers']) {
                    this.NodeSnippet = this.NodeSnippet + '\'' + parameter['key'] + '\' : \'' + parameter['value'] + '\',\n';
                }
                this.NodeSnippet = this.NodeSnippet + '}\n';
                this.NodeSnippet = this.NodeSnippet + '};\n';
                this.NodeSnippet = this.NodeSnippet + 'request(options, function (error, response) {\n';
                this.NodeSnippet = this.NodeSnippet + 'if (error) throw new Error(error);\n';
                this.NodeSnippet = this.NodeSnippet + 'console.log(response.body);\n';
                this.NodeSnippet = this.NodeSnippet + '});\n';

                this.GoSnippet = 'package main\n';
                this.GoSnippet = this.GoSnippet + 'import (\n';
                this.GoSnippet = this.GoSnippet + '\"fmt\"\n';
                this.GoSnippet = this.GoSnippet + '\"net/http\"\n';
                this.GoSnippet = this.GoSnippet + '\"io/ioutil\"\n';
                this.GoSnippet = this.GoSnippet + ')\n';
                this.GoSnippet = this.GoSnippet + 'func main() {\n';
                this.GoSnippet = this.GoSnippet + 'url := \"' + operations['apiUrl'] + '\"\n';
                this.GoSnippet = this.GoSnippet + 'method := \"GET\"\n';
                this.GoSnippet = this.GoSnippet + 'client := \&http.Client {\n';
                this.GoSnippet = this.GoSnippet + '}\n';
                this.GoSnippet = this.GoSnippet + 'req, err := http.NewRequest(method, url, nil)\n';
                this.GoSnippet = this.GoSnippet + 'if err!= nil {\n';
                this.GoSnippet = this.GoSnippet + 'fmt.Println(err)\n';
                this.GoSnippet = this.GoSnippet + '}\n';
                for (const parameter of operations['headers']) {
                    this.GoSnippet = this.GoSnippet + 'req.Header.Add(\"' + parameter['key'] + '\", \"' + parameter['value'] + '\")\n';
                }
                this.GoSnippet = this.GoSnippet + 'res, err := client.Do(req)\n';
                this.GoSnippet = this.GoSnippet + 'defer res.Body.Close()\n';
                this.GoSnippet = this.GoSnippet + 'body, err := ioutil.ReadAll(res.Body)\n';
                this.GoSnippet = this.GoSnippet + 'fmt.Println(string(body))\n';
                this.GoSnippet = this.GoSnippet + '}\n';

                this.RubySnippet = 'require \"uri\"\n';
                this.RubySnippet = this.RubySnippet + 'require \"net/http\"\n';
                this.RubySnippet = this.RubySnippet + 'url = URI(\"' + operations['apiUrl'] + '\")\n';
                this.RubySnippet = this.RubySnippet + 'http = Net::HTTP.new(url.host, url.port);\n';
                this.RubySnippet = this.RubySnippet + 'request = Net::HTTP::Get.new(url)\n';
                for (const parameter of operations['headers']) {
                    this.RubySnippet = this.RubySnippet + 'request[\"' + parameter['key'] + '\"] = \"' + parameter['value'] + '\"\n';
                }
                this.RubySnippet = this.RubySnippet + 'response = http.request(request)\n';
                this.RubySnippet = this.RubySnippet + 'puts response.read_body';
            } else if (operations['executor_method_type'] === 'PUT') {
                this.curlSnippet = 'curl --location --request PUT \'' + operations['apiUrl'] + '\'';
                for (const parameter of operations['headers']) {
                    this.curlSnippet = this.curlSnippet + ' --header \'' + parameter['key'] + ':' + parameter['value'] + '\'';
                }

                this.JSSnippet = 'var setting = {\n';
                this.JSSnippet = this.JSSnippet + '\"url\":\"' + operations['apiUrl'] + '\",\n';
                this.JSSnippet = this.JSSnippet + '\"method\": \"PUT\",\n';
                this.JSSnippet = this.JSSnippet + '\"timeout\": 0,\n';
                this.JSSnippet = this.JSSnippet + '\"headers\": {\n';
                for (const parameter of operations['headers']) {
                    this.JSSnippet = this.JSSnippet + '\"' + parameter['key'] + '\" : \"' + parameter['value'] + '\",\n';
                }
                this.JSSnippet = this.JSSnippet + '},\n';
                this.JSSnippet = this.JSSnippet + '};\n';
                this.JSSnippet = this.JSSnippet + '$.ajax(setting).done(function (response) {';
                this.JSSnippet = this.JSSnippet + 'console.log(response);';
                this.JSSnippet = this.JSSnippet + '});\n';

                this.JavaSnippet = 'OkHttpClient client = new OkHttpClient().newBuilder().build();\n';
                this.JavaSnippet = this.JavaSnippet + 'MediaType mediaType = MediaType.parse(\"text/plain\")\n';
                this.JavaSnippet = this.JavaSnippet + 'RequestBody body = RequestBody.create(mediaType, \"\")\n';
                this.JavaSnippet = this.JavaSnippet + 'Request request = new Request.Builder()\n';
                this.JavaSnippet = this.JavaSnippet + '.url(\"' + operations['apiUrl'] + '\")\n';
                this.JavaSnippet = this.JavaSnippet + '.method(\"PUT\", null)\n';
                for (const parameter of operations['headers']) {
                    this.JavaSnippet = this.JavaSnippet + '.addHeader(\"' + parameter['key'] + '\" , \"' + parameter['value'] + '\")\n';
                }
                this.JavaSnippet = this.JavaSnippet + '.build();\n';
                this.JavaSnippet = this.JavaSnippet + 'Response response = call.newCall(request).execute();';

                this.GoSnippet = 'package main\n';
                this.GoSnippet = this.GoSnippet + 'import (\n';
                this.GoSnippet = this.GoSnippet + '\"fmt\"\n';
                this.GoSnippet = this.GoSnippet + '\"net/http\"\n';
                this.GoSnippet = this.GoSnippet + '\"io/ioutil\"\n';
                this.GoSnippet = this.GoSnippet + ')\n';
                this.GoSnippet = this.GoSnippet + 'func main() {\n';
                this.GoSnippet = this.GoSnippet + 'url := \"' + operations['apiUrl'] + '\"\n';
                this.GoSnippet = this.GoSnippet + 'method := \"PUT\"\n';
                this.GoSnippet = this.GoSnippet + 'client := \&http.Client {\n';
                this.GoSnippet = this.GoSnippet + '}\n';
                this.GoSnippet = this.GoSnippet + 'req, err := http.NewRequest(method, url, nil)\n';
                this.GoSnippet = this.GoSnippet + 'if err!= nil {\n';
                this.GoSnippet = this.GoSnippet + 'fmt.Println(err)\n';
                this.GoSnippet = this.GoSnippet + '}\n';
                for (const parameter of operations['headers']) {
                    this.GoSnippet = this.GoSnippet + 'req.Header.Add(\"' + parameter['key'] + '\", \"' + parameter['value'] + '\")\n';
                }
                this.GoSnippet = this.GoSnippet + 'res, err := client.Do(req)\n';
                this.GoSnippet = this.GoSnippet + 'defer res.Body.Close()\n';
                this.GoSnippet = this.GoSnippet + 'body, err := ioutil.ReadAll(res.Body)\n';
                this.GoSnippet = this.GoSnippet + 'fmt.Println(string(body))\n';
                this.GoSnippet = this.GoSnippet + '}\n';

                this.PySnippet = 'import http.client\n';
                this.PySnippet = this. PySnippet + 'url_parts = http.client.urlsplit( "' + operations['apiUrl']+'")\n'
                this.PySnippet = this.PySnippet + 'conn = http.client.HTTPSConnection(url_parts.hostname )\n';
                this.PySnippet = this.PySnippet + 'payload = \'\'\n';
                this.PySnippet = this.PySnippet + 'headers = {';
                for (const parameter of operations['headers']) {
                    this.PySnippet = this.PySnippet + '\'' + parameter['key'] + '\' : \'' + parameter['value'] + '\',\n';
                }
                this.PySnippet = this.PySnippet + '}\n';
                this.PySnippet = this.PySnippet + 'conn.request("PUT", url_parts.path, payload, headers)\n';
                this.PySnippet = this.PySnippet + 'res = conn.getresponse()\n';
                this.PySnippet = this.PySnippet + 'data = res.read()\n';
                this.PySnippet = this.PySnippet + 'print(data.decode("utf-8"))\n';

                this.NodeSnippet = 'var request = require(\'request\');\n';
                this.NodeSnippet = this.NodeSnippet + 'var options = {\n';
                this.NodeSnippet = this.NodeSnippet + '\'method\': \'PUT\',\n';
                this.NodeSnippet = this.NodeSnippet + '\'url\': \'' + operations['apiUrl'] + '\',\n';
                this.NodeSnippet = this.NodeSnippet + '\'headers\': {\n';
                for (const parameter of operations['headers']) {
                    this.NodeSnippet = this.NodeSnippet + '\'' + parameter['key'] + '\' : \'' + parameter['value'] + '\',\n';
                }
                this.NodeSnippet = this.NodeSnippet + '}\n';
                this.NodeSnippet = this.NodeSnippet + '};\n';
                this.NodeSnippet = this.NodeSnippet + 'request(options, function (error, response) {\n';
                this.NodeSnippet = this.NodeSnippet + 'if (error) throw new Error(error);\n';
                this.NodeSnippet = this.NodeSnippet + 'console.log(response.body);\n';
                this.NodeSnippet = this.NodeSnippet + '});\n';

                this.RubySnippet = 'require \"uri\"\n';
                this.RubySnippet = this.RubySnippet + 'require \"net/http\"\n';
                this.RubySnippet = this.RubySnippet + 'url = URI(\"' + operations['apiUrl'] + '\")\n';
                this.RubySnippet = this.RubySnippet + 'http = Net::HTTP.new(url.host, url.port);\n';
                this.RubySnippet = this.RubySnippet + 'request = Net::HTTP::Post.new(url)\n';
                for (const parameter of operations['headers']) {
                    this.RubySnippet = this.RubySnippet + 'request[\"' + parameter['key'] + '\"] = \"' + parameter['value'] + '\"\n';
                }
                this.RubySnippet = this.RubySnippet + 'response = http.request(request)\n';
                this.RubySnippet = this.RubySnippet + 'puts response.read_body';
            } else if (operations['executor_method_type'] === 'POST') {
                this.curlSnippet = 'curl --location --request POST \'' + operations['apiUrl'] + '\'';
                for (const parameter of operations['headers']) {
                    this.curlSnippet = this.curlSnippet + ' --header \'' + parameter['key'] + ':' + parameter['value'] + '\'';
                }
                // console.log(operations['apiUrl'], "op")

                this.JSSnippet = 'var setting = {\n';
                this.JSSnippet = this.JSSnippet + '\"url\":\"' + operations['apiUrl'] + '\",\n';
                this.JSSnippet = this.JSSnippet + '\"method\": \"POST\",\n';
                this.JSSnippet = this.JSSnippet + '\"timeout\": 0,\n';
                this.JSSnippet = this.JSSnippet + '\"headers\": {\n';
                for (const parameter of operations['headers']) {
                    this.JSSnippet = this.JSSnippet + '\"' + parameter['key'] + '\" : \"' + parameter['value'] + '\",\n';
                }
                this.JSSnippet = this.JSSnippet + '},\n';
                this.JSSnippet = this.JSSnippet + '};\n';
                this.JSSnippet = this.JSSnippet + '$.ajax(setting).done(function (response) {';
                this.JSSnippet = this.JSSnippet + 'console.log(response);';
                this.JSSnippet = this.JSSnippet + '});\n';

                this.JavaSnippet = 'OkHttpClient client = new OkHttpClient().newBuilder().build();\n';
                this.JavaSnippet = this.JavaSnippet + 'MediaType mediaType = MediaType.parse(\"text/plain\")\n';
                this.JavaSnippet = this.JavaSnippet + 'RequestBody body = RequestBody.create(mediaType, \"\")\n';
                this.JavaSnippet = this.JavaSnippet + 'Request request = new Request.Builder()\n';
                this.JavaSnippet = this.JavaSnippet + '.url(\"' + operations['apiUrl'] + '\")\n';
                this.JavaSnippet = this.JavaSnippet + '.method(\"POST\", null)\n';
                for (const parameter of operations['headers']) {
                    this.JavaSnippet = this.JavaSnippet + '.addHeader(\"' + parameter['key'] + '\" , \"' + parameter['value'] + '\")\n';
                }
                this.JavaSnippet = this.JavaSnippet + '.build();\n';
                this.JavaSnippet = this.JavaSnippet + 'Response response = call.newCall(request).execute();';

                this.GoSnippet = 'package main\n';
                this.GoSnippet = this.GoSnippet + 'import (\n';
                this.GoSnippet = this.GoSnippet + '\"fmt\"\n';
                this.GoSnippet = this.GoSnippet + '\"net/http\"\n';
                this.GoSnippet = this.GoSnippet + '\"io/ioutil\"\n';
                this.GoSnippet = this.GoSnippet + ')\n';
                this.GoSnippet = this.GoSnippet + 'func main() {\n';
                this.GoSnippet = this.GoSnippet + 'url := \"' + operations['apiUrl'] + '\"\n';
                this.GoSnippet = this.GoSnippet + 'method := \"POST\"\n';
                this.GoSnippet = this.GoSnippet + 'client := \&http.Client {\n';
                this.GoSnippet = this.GoSnippet + '}\n';
                this.GoSnippet = this.GoSnippet + 'req, err := http.NewRequest(method, url, nil)\n';
                this.GoSnippet = this.GoSnippet + 'if err!= nil {\n';
                this.GoSnippet = this.GoSnippet + 'fmt.Println(err)\n';
                this.GoSnippet = this.GoSnippet + '}\n';
                for (const parameter of operations['headers']) {
                    this.GoSnippet = this.GoSnippet + 'req.Header.Add(\"' + parameter['key'] + '\", \"' + parameter['value'] + '\")\n';
                }
                this.GoSnippet = this.GoSnippet + 'res, err := client.Do(req)\n';
                this.GoSnippet = this.GoSnippet + 'defer res.Body.Close()\n';
                this.GoSnippet = this.GoSnippet + 'body, err := ioutil.ReadAll(res.Body)\n';
                this.GoSnippet = this.GoSnippet + 'fmt.Println(string(body))\n';
                this.GoSnippet = this.GoSnippet + '}\n';

                this.PySnippet = 'import http.client\n';
                this.PySnippet = this. PySnippet + 'url_parts = http.client.urlsplit( "' + operations['apiUrl']+'")\n'
                this.PySnippet = this.PySnippet + 'conn = http.client.HTTPSConnection(url_parts.hostname)\n';
                this.PySnippet = this.PySnippet + 'payload = \'\'\n';
                this.PySnippet = this.PySnippet + 'headers = {';
                for (const parameter of operations['headers']) {
                    this.PySnippet = this.PySnippet + '\'' + parameter['key'] + '\' : \'' + parameter['value'] + '\',\n';
                }
                this.PySnippet = this.PySnippet + '}\n';
                this.PySnippet = this.PySnippet + 'conn.request("POST", url_parts.path, payload, headers)\n';
                this.PySnippet = this.PySnippet + 'res = conn.getresponse()\n';
                this.PySnippet = this.PySnippet + 'data = res.read()\n';
                this.PySnippet = this.PySnippet + 'print(data.decode("utf-8"))\n';

                this.NodeSnippet = 'var request = require(\'request\');\n';
                this.NodeSnippet = this.NodeSnippet + 'var options = {\n';
                this.NodeSnippet = this.NodeSnippet + '\'method\': \'POST\',\n';
                this.NodeSnippet = this.NodeSnippet + '\'url\': \'' + operations['apiUrl'] + '\',\n';
                this.NodeSnippet = this.NodeSnippet + '\'headers\': {\n';
                for (const parameter of operations['headers']) {
                    this.NodeSnippet = this.NodeSnippet + '\'' + parameter['key'] + '\' : \'' + parameter['value'] + '\',\n';
                }
                this.NodeSnippet = this.NodeSnippet + '}\n';
                this.NodeSnippet = this.NodeSnippet + '};\n';
                this.NodeSnippet = this.NodeSnippet + 'request(options, function (error, response) {\n';
                this.NodeSnippet = this.NodeSnippet + 'if (error) throw new Error(error);\n';
                this.NodeSnippet = this.NodeSnippet + 'console.log(response.body);\n';
                this.NodeSnippet = this.NodeSnippet + '});\n';

                this.RubySnippet = 'require \"uri\"\n';
                this.RubySnippet = this.RubySnippet + 'require \"net/http\"\n';
                this.RubySnippet = this.RubySnippet + 'url = URI(\"' + operations['apiUrl'] + '\")\n';
                this.RubySnippet = this.RubySnippet + 'http = Net::HTTP.new(url.host, url.port);\n';
                this.RubySnippet = this.RubySnippet + 'request = Net::HTTP::Post.new(url)\n';
                for (const parameter of operations['headers']) {
                    this.RubySnippet = this.RubySnippet + 'request[\"' + parameter['key'] + '\"] = \"' + parameter['value'] + '\"\n';
                }
                this.RubySnippet = this.RubySnippet + 'response = http.request(request)\n';
                this.RubySnippet = this.RubySnippet + 'puts response.read_body';
            } else if (operations['executor_method_type'] === 'DELETE') {

                this.curlSnippet = 'curl --location --request DELETE \'' + operations['apiUrl'] + '\'';
                for (const parameter of operations['headers']) {
                    this.curlSnippet = this.curlSnippet + ' --header \'' + parameter['key'] + ':' + parameter['value'] + '\'';
                }

                this.JavaSnippet = 'OkHttpClient client = new OkHttpClient().newBuilder().build();\n';
                this.JavaSnippet = this.JavaSnippet + 'MediaType mediaType = MediaType.parse(\"text/plain\")\n';
                this.JavaSnippet = this.JavaSnippet + 'RequestBody body = RequestBody.create(mediaType, \"\")\n';
                this.JavaSnippet = this.JavaSnippet + 'Request request = new Request.Builder()\n';
                this.JavaSnippet = this.JavaSnippet + '.url(\"' + operations['apiUrl'] + '\")\n';
                this.JavaSnippet = this.JavaSnippet + '.method(\"DELETE\", null)\n';
                for (const parameter of operations['headers']) {
                    this.JavaSnippet = this.JavaSnippet + '.addHeader(\"' + parameter['key'] + '\" , \"' + parameter['value'] + '\")\n';
                }
                this.JavaSnippet = this.JavaSnippet + '.build();\n';
                this.JavaSnippet = this.JavaSnippet + 'Response response = call.newCall(request).execute();';

                this.JSSnippet = 'var setting = {\n';
                this.JSSnippet = this.JSSnippet + '\"url\":\"' + operations['apiUrl'] + '\",\n';
                this.JSSnippet = this.JSSnippet + '\"method\": \"DELETE\",\n';
                this.JSSnippet = this.JSSnippet + '\"timeout\": 0,\n';
                this.JSSnippet = this.JSSnippet + '\"headers\": {\n';
                for (const parameter of operations['headers']) {
                    this.JSSnippet = this.JSSnippet + '\"' + parameter['key'] + '\" : \"' + parameter['value'] + '\",\n';
                }
                this.JSSnippet = this.JSSnippet + '},\n';
                this.JSSnippet = this.JSSnippet + '};\n';
                this.JSSnippet = this.JSSnippet + '$.ajax(setting).done(function (response) {';
                this.JSSnippet = this.JSSnippet + 'console.log(response);';
                this.JSSnippet = this.JSSnippet + '});\n';

                this.NodeSnippet = 'var request = require(\'request\');\n';
                this.NodeSnippet = this.NodeSnippet + 'var options = {\n';
                this.NodeSnippet = this.NodeSnippet + '\'method\': \'DELETE\',\n';
                this.NodeSnippet = this.NodeSnippet + '\'url\': \'' + operations['apiUrl'] + '\',\n';
                this.NodeSnippet = this.NodeSnippet + '\'headers\': {\n';
                for (const parameter of operations['headers']) {
                    this.NodeSnippet = this.NodeSnippet + '\'' + parameter['key'] + '\' : \'' + parameter['value'] + '\',\n';
                }
                this.NodeSnippet = this.NodeSnippet + '}\n';
                this.NodeSnippet = this.NodeSnippet + '};\n';
                this.NodeSnippet = this.NodeSnippet + 'request(options, function (error, response) {\n';
                this.NodeSnippet = this.NodeSnippet + 'if (error) throw new Error(error);\n';
                this.NodeSnippet = this.NodeSnippet + 'console.log(response.body);\n';
                this.NodeSnippet = this.NodeSnippet + '});\n';

                this.GoSnippet = 'package main\n';
                this.GoSnippet = this.GoSnippet + 'import (\n';
                this.GoSnippet = this.GoSnippet + '\"fmt\"\n';
                this.GoSnippet = this.GoSnippet + '\"net/http\"\n';
                this.GoSnippet = this.GoSnippet + '\"io/ioutil\"\n';
                this.GoSnippet = this.GoSnippet + ')\n';
                this.GoSnippet = this.GoSnippet + 'func main() {\n';
                this.GoSnippet = this.GoSnippet + 'url := \"' + operations['apiUrl'] + '\"\n';
                this.GoSnippet = this.GoSnippet + 'method := \"DELETE\"\n';
                this.GoSnippet = this.GoSnippet + 'client := \&http.Client {\n';
                this.GoSnippet = this.GoSnippet + '}\n';
                this.GoSnippet = this.GoSnippet + 'req, err := http.NewRequest(method, url, nil)\n';
                this.GoSnippet = this.GoSnippet + 'if err!= nil {\n';
                this.GoSnippet = this.GoSnippet + 'fmt.Println(err)\n';
                this.GoSnippet = this.GoSnippet + '}\n';
                for (const parameter of operations['headers']) {
                    this.GoSnippet = this.GoSnippet + 'req.Header.Add(\"' + parameter['key'] + '\", \"' + parameter['value'] + '\")\n';
                }
                this.GoSnippet = this.GoSnippet + 'res, err := client.Do(req)\n';
                this.GoSnippet = this.GoSnippet + 'defer res.Body.Close()\n';
                this.GoSnippet = this.GoSnippet + 'body, err := ioutil.ReadAll(res.Body)\n';
                this.GoSnippet = this.GoSnippet + 'fmt.Println(string(body))\n';
                this.GoSnippet = this.GoSnippet + '}\n';

                this.PySnippet = 'import http.client\n';
                this.PySnippet = this. PySnippet + 'url_parts = http.client.urlsplit( "' + operations['apiUrl']+'")\n'
                this.PySnippet = this.PySnippet + 'conn = http.client.HTTPSConnection(url_parts.hostname)\n';
                this.PySnippet = this.PySnippet + 'payload = \'\'\n';
                this.PySnippet = this.PySnippet + 'headers = {';
                for (const parameter of operations['headers']) {
                    this.PySnippet = this.PySnippet + '\'' + parameter['key'] + '\' : \'' + parameter['value'] + '\',\n';
                }
                this.PySnippet = this.PySnippet + '}\n';
                this.PySnippet = this.PySnippet + 'conn.request("DELETE", url_parts.path, payload, headers)\n';
                this.PySnippet = this.PySnippet + 'res = conn.getresponse()\n';
                this.PySnippet = this.PySnippet + 'data = res.read()\n';
                this.PySnippet = this.PySnippet + 'print(data.decode("utf-8"))\n';

                this.RubySnippet = 'require \"uri\"\n';
                this.RubySnippet = this.RubySnippet + 'require \"net/http\"\n';
                this.RubySnippet = this.RubySnippet + 'url = URI(\"' + operations['apiUrl'] + '\")\n';
                this.RubySnippet = this.RubySnippet + 'http = Net::HTTP.new(url.host, url.port);\n';
                this.RubySnippet = this.RubySnippet + 'request = Net::HTTP::Delete.new(url)\n';
                for (const parameter of operations['headers']) {
                    this.RubySnippet = this.RubySnippet + 'request[\"' + parameter['key'] + '\"] = \"' + parameter['value'] + '\"\n';
                }
                this.RubySnippet = this.RubySnippet + 'response = http.request(request)\n';
                this.RubySnippet = this.RubySnippet + 'puts response.read_body';
            }
        }
    }

    changeOption(value) {
        this.dropDownVar = value;
        this.updateCurrentSnippet()
    }
}
